import { SearchFilters } from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import useDrumBall from "./useDrumBall";
import Style from "./drumBall.module.scss";
import OrderCardListing from "../../Global/OrderCardListing";
import DrumBallCertificate from "./DrumBallCertificate";

const DrumBall = () => {
  const {
    gliNumber,
    showDetail,
    activeCard,
    drumBallData,
    totalLength,
    isLoading,
    apiStatus,
    handleSearch,
    handleSearchInput,
    handleChange,
    handleLoadMore,
    setIsLoading,
  } = useDrumBall();

  return (
    <>
      <div className="row pro-mb-4 gx-2">
        <div className="col-auto">
          <SearchFilters
            showDateRange={false}
            onSearchInput={handleSearchInput}
            showFilters={true}
            showActions={false}
            SearchIcon={
              <span className="material-symbols-outlined"> search </span>
            }
            searchInputProps={{
              onKeyDown: (e) => e.key === "Enter" && handleSearch(),
              placeholder: "Search GLI Number",
            }}
          />
        </div>
        <div className={`col-auto`}>
          <button
            className="pro-btn pro-btn-primary"
            onClick={handleSearch}
            type="button"
          >
            <span className="material-symbols-outlined">search</span>
            Search
          </button>
        </div>
      </div>
      <div className={Style.varifaication_main_wrap}>
        <div className="row">
          <div className={`col-4 ${Style.card_main_wrapper}`}>
            <div className={`pro-d-flex ${Style.card_flow_wrap}`}>
              <OrderCardListing
                data={drumBallData}
                handleChange={handleChange}
                activeCard={activeCard}
                isLoading={isLoading}
                totalLength={totalLength}
                setIsLoading={setIsLoading}
                handleLoadMore={handleLoadMore}
                apiStatus={apiStatus}
                refBottom
              />
            </div>
          </div>
          {showDetail === true && (
            <div className={`col-8 pro-pe-0 ${Style.table_main_wrapper}`}>
              <div className={`${Style.table_flow_wrapper}`}>
                <DrumBallCertificate gliNumber={gliNumber} />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DrumBall;
